"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPaymentOptionsRequest = exports.transformPaymentOptionsResponse = exports.PaymentGatewayName = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("./Error");
var PaymentGatewayName;
(function (PaymentGatewayName) {
    PaymentGatewayName["WePay"] = "fbpay";
    PaymentGatewayName["Stripe"] = "stripe";
    PaymentGatewayName["PayPal"] = "paypal";
})(PaymentGatewayName = exports.PaymentGatewayName || (exports.PaymentGatewayName = {}));
function transformPaymentOptionsResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isOnlinePaymentErrorResponse)(status, response)) {
        return (0, Error_1.transformOnlinePaymentsErrorResponse)(response);
    }
    const paymentOptions = response['payment_options'];
    return transformPaymentOptionsParsedResponse(paymentOptions);
}
exports.transformPaymentOptionsResponse = transformPaymentOptionsResponse;
function transformPaymentOptionsParsedResponse(options) {
    return {
        gatewayName: options.gateway_name,
        hasCreditCard: options.has_credit_card,
        hasAchTransfer: options.has_ach_transfer,
        hasBacsDebit: options.has_bacs_debit,
        hasSepaDebit: options.has_sepa_debit,
        hasPayPalSmartCheckout: options.has_paypal_smart_checkout,
        allowPartialPayments: options.allow_partial_payments,
        entityId: options.entity_id,
        entityType: options.entity_type,
    };
}
function transformPaymentOptionsRequest(options) {
    return JSON.stringify({
        gateway_name: options.gatewayName,
        entity_type: options.entityType,
        entity_id: options.entityId,
        allow_partial_payments: options.allowPartialPayments,
        has_paypal_smart_checkout: options.hasPayPalSmartCheckout,
        has_sepa_debit: options.hasSepaDebit,
        has_bacs_debit: options.hasBacsDebit,
        has_ach_transfer: options.hasAchTransfer,
        has_credit_card: options.hasCreditCard,
    });
}
exports.transformPaymentOptionsRequest = transformPaymentOptionsRequest;
//# sourceMappingURL=PaymentOptions.js.map